import axios from "axios";
import { SAVE_JOB_POST_URL } from "../utils";

export const saveJobPost = async (jobPostId: string) => {
  return await axios.post(SAVE_JOB_POST_URL, {
    jobPostId,
  });
};
